// import React, { useState } from "react";
// import { Box, Typography, Button, Snackbar, Alert, CircularProgress, TextField, Grid, useTheme, useMediaQuery } from "@mui/material";
// import StockReportFilterDialog from "./StockReportFilterDialog";
// import { DataGrid } from "@mui/x-data-grid";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import BarChartIcon from '@mui/icons-material/BarChart';
// import ClearIcon from '@mui/icons-material/Clear';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import TuneIcon from '@mui/icons-material/Tune';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// // ─── ENTERPRISE ERP DESIGN TOKENS ─────────────────────────────────────
// const NAVY     = "#0D2137";
// const STEEL    = "#1B4FBB";
// const STEEL_LT = "#EBF2FF";
// const PAGE_BG  = "#F4F6F9";
// const CARD     = "#FFFFFF";
// const BORDER   = "#E2E8F0";
// const TH_BG    = "#F7F9FC";
// const T1       = "#1A202C";
// const T2       = "#4A5568";
// const T3       = "#718096";
// const POS      = "#276749";
// const WHITE    = "#FFFFFF";
// // Legacy aliases (used in StatCard / MobileCard helpers below)
// const FB       = STEEL;
// const FB_LIGHT = STEEL_LT;
// const FB_DARK = NAVY;
// const G200     = "#EEEEEE";
// const G300     = BORDER;
// const G500     = T3;
// const G700     = T2;
// const G900     = T1;

// // ─── SHARED SX HELPERS ────────────────────────────────────────────────
// const cardSx = {
//     background: CARD,
//     border: `1px solid ${BORDER}`,
//     borderRadius: "6px",
//     p: { xs: 1.5, sm: 2 },
// };
// const inputSx = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: "4px", background: WHITE, fontSize: 13, height: 36,
//         "& fieldset": { borderColor: BORDER },
//         "&:hover fieldset": { borderColor: STEEL },
//         "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//     },
//     "& .MuiInputLabel-root": { fontSize: 13, color: T3 },
// };
// const btnPrimary = {
//     background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//     textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
//     "&:hover": { background: "#1640A0" },
//     "&:disabled": { background: BORDER, color: T3 },
// };
// const btnOutline = {
//     background: "transparent", color: STEEL, border: `1px solid ${BORDER}`,
//     borderRadius: "4px", fontSize: 12, fontWeight: 500,
//     textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
//     "&:hover": { background: STEEL_LT },
// };
// const btnGhost = {
//     background: "transparent", color: T2, border: `1px solid ${BORDER}`,
//     borderRadius: "4px", fontSize: 12, fontWeight: 500,
//     textTransform: "none", px: 1.5, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: PAGE_BG, color: T1 },
// };
// const btnHeaderGhost = {
//     color: "rgba(255,255,255,0.88)", border: "1px solid rgba(255,255,255,0.25)",
//     background: "transparent", borderRadius: "4px", fontSize: 12, fontWeight: 500,
//     textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: "rgba(255,255,255,0.1)" },
//     "&:disabled": { color: "rgba(255,255,255,0.3)" },
// };
// const btnHeaderSolid = {
//     color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
//     textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: "#E8EDF5" },
// };
// const dgSx = {
//     border: "none",
//     "& .MuiDataGrid-columnHeaders": { background: TH_BG, borderBottom: `1px solid ${BORDER}` },
//     "& .MuiDataGrid-columnHeaderTitle": { fontSize: 11, fontWeight: 700, color: T2, letterSpacing: ".5px", textTransform: "uppercase" },
//     "& .MuiDataGrid-cell": { borderBottom: `1px solid ${BORDER}`, outline: "none !important", display: "flex", alignItems: "center" },
//     "& .MuiDataGrid-row:hover": { background: STEEL_LT },
//     "& .MuiDataGrid-row:nth-of-type(even)": { background: "#FAFBFD" },
//     "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${BORDER}`, background: TH_BG },
//     "& .MuiTablePagination-root": { fontSize: 12, color: T2 },
// };

// // ─── STAT CARD ────────────────────────────────────────────────────────
// function StatCard({ label, value, icon }) {
//     return (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", p: "12px 14px", flex: 1, minWidth: 0 }}>
//             <Box sx={{ width: 34, height: 34, borderRadius: "9px", background: FB_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                 {icon}
//             </Box>
//             <Box sx={{ minWidth: 0 }}>
//                 <Typography sx={{ fontSize: 11, color: G500, fontWeight: 500, mb: "2px" }}>{label}</Typography>
//                 <Typography sx={{ fontSize: 15, fontWeight: 600, color: G900 }} noWrap>{value}</Typography>
//             </Box>
//         </Box>
//     );
// }

// // ─── MOBILE ITEM CARD ─────────────────────────────────────────────────
// function MobileCard({ row, fmt, reportType }) {
//     return (
//         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: "12px", mb: 1 }}>
//             <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1 }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{row.itemCode}</Typography>
//                     <Typography sx={{ fontSize: 12, color: G500, mt: "1px" }} noWrap>{row.description}</Typography>
//                 </Box>
//                 <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px", flexShrink: 0, ml: 1 }}>
//                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{row.unit}</Typography>
//                 </Box>
//             </Box>
//             <Grid container spacing={0.75}>
//                 {reportType !== "General Stock Report" ? (
//                     <>
//                         {[
//                             { k: "Op. Stock",   v: row.OpStock,         c: G900 },
//                             { k: "Inward",      v: row.inward,          c: FB   },
//                             { k: "Outward",     v: row.outward,         c: G700 },
//                             { k: "Closing",     v: row.closing,         c: FB   },
//                             { k: "Avg. Rate",   v: row.avgRate,         c: G900 },
//                             { k: "Amount (Rs.)",v: row.stockValuation,  c: G900 },
//                         ].map(({ k, v, c }) => (
//                             <Grid item xs={6} key={k}>
//                                 <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
//                                     <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
//                                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
//                                 </Box>
//                             </Grid>
//                         ))}
//                     </>
//                 ) : (
//                     <>
//                         {[
//                             { k: "Op. Stock", v: row.OpStock,  c: G900 },
//                             { k: "Inward",    v: row.inward,   c: FB   },
//                             { k: "Outward",   v: row.outward,  c: G700 },
//                             { k: "Closing",   v: row.closing,  c: FB   },
//                         ].map(({ k, v, c }) => (
//                             <Grid item xs={6} key={k}>
//                                 <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
//                                     <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
//                                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
//                                 </Box>
//                             </Grid>
//                         ))}
//                     </>
//                 )}
//             </Grid>
//         </Box>
//     );
// }

// // ─── MOBILE LEDGER CARD ───────────────────────────────────────────────
// function MobileLedgerCard({ row, fmt }) {
//     return (
//         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: "12px", mb: 1 }}>
//             <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1 }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{row.stockDate}</Typography>
//                     <Typography sx={{ fontSize: 12, color: G500, mt: "1px" }} noWrap>{row.docNo || "—"}</Typography>
//                 </Box>
//                 <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px", flexShrink: 0, ml: 1 }}>
//                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{row.bookName}</Typography>
//                 </Box>
//             </Box>
//             <Grid container spacing={0.75}>
//                 {[
//                     { k: "Op. Stock", v: row.opStock,     c: G900 },
//                     { k: "Inward",    v: row.stockInQty,  c: FB   },
//                     { k: "Outward",   v: row.stockOutQty, c: G700 },
//                     { k: "Closing",   v: row.balance,     c: FB   },
//                     { k: "Rate",      v: row.rate,         c: G900 },
//                     { k: "Disc",      v: row.disc,         c: G700 },
//                 ].map(({ k, v, c }) => (
//                     <Grid item xs={6} key={k}>
//                         <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
//                             <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
//                             <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
//                         </Box>
//                     </Grid>
//                 ))}
//             </Grid>
//         </Box>
//     );
// }

// // ─── MAIN COMPONENT ───────────────────────────────────────────────────
// export default function StockReport({ connectionString, pdfString }) {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//     const { user, selectedCompany } = useAuth();
//     const companyId = selectedCompany?.CompId;
//     const getTodayDate = () => new Date().toISOString().split("T")[0];

//     const [rows, setRows] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [excelLoading, setExcelLoading] = useState(false);

//     const [fromDate, setFromDate] = useState(getTodayDate());
//     const [toDate, setToDate] = useState(getTodayDate());
//     const [reportType, setReportType] = useState("General Stock Report");
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

//     const [filterOpen, setFilterOpen] = useState(false);
//     const [appliedFilters, setAppliedFilters] = useState(null);

//     const [showZeroRecords, setShowZeroRecords] = useState(false);
//     const [tempShowZeroRecords, setTempShowZeroRecords] = useState(false);

//     const [tempFromDate, setTempFromDate] = useState(getTodayDate());
//     const [tempToDate, setTempToDate] = useState(getTodayDate());
//     const [tempReportType, setTempReportType] = useState("General Stock Report");

//     const [currentView, setCurrentView] = useState("report");
//     const [ledgerRows, setLedgerRows] = useState([]);
//     const [ledgerLoading, setLedgerLoading] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [ledgerExcelLoading, setLedgerExcelLoading] = useState(false);

//     const [itemGroups, setItemGroups] = useState([]);
//     const [itemGroupsLoading, setItemGroupsLoading] = useState(false);
//     const [selectedGroupIds, setSelectedGroupIds] = useState([]);
//     const [tempSelectedGroupIds, setTempSelectedGroupIds] = useState([]);

//     const [pdfLoading, setPdfLoading] = useState(false);

//     const fmt = (n) => Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     const filteredRows = (showZeroRecords
//         ? rows
//         : rows.filter((r) => !(Number(r.OpStock || 0) === 0 && Number(r.inward || 0) === 0 && Number(r.outward || 0) === 0))
//     ).map((r, idx) => ({ ...r, srNo: idx + 1 }));

//     const totOp  = filteredRows.reduce((s, r) => s + Number(r.OpStock || 0), 0);
//     const totIn  = filteredRows.reduce((s, r) => s + Number(r.inward  || 0), 0);
//     const totOut = filteredRows.reduce((s, r) => s + Number(r.outward || 0), 0);
//     const totCl  = filteredRows.reduce((s, r) => s + Number(r.closing || 0), 0);
//     const totStockVal = filteredRows.reduce((s, r) => s + Number(r.stockValuation || 0), 0);

//     const reportOptions = [
//         "General Stock Report",
//         "Average Rate",
//         "Purchase Rate",
//         "Last Purchase Rate",
//         "Min Level",
//         "Max Level",
//         "Groupwise Item",
//     ];

//     const getReportFormat = (type) => ({
//         "General Stock Report": "format_1",
//         "Average Rate":         "format_2",
//         "Purchase Rate":        "format_3",
//         "Last Purchase Rate":   "format_4",
//         "Min Level":            "format_5",
//         "Max Level":            "format_6",
//         "Groupwise Item":       "format_7",
//     }[type] || "format_1");

//     // ─── STOCK PDF ────────────────────────────────────────────────────────
//     const handleStockPdf = async () => {
//         if (!filteredRows.length) return;
//         setPdfLoading(true);
//         try {
//             let imageBase64 = null;
//             try {
//                 const iconRes = await axios.get(`${connectionString}/company/GetIcon/${encodeURIComponent(companyId)}`);
//                 if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                     const raw = iconRes.data.imageBase64;
//                     imageBase64 = typeof raw === "string" ? raw.split("base64,").pop()?.replace(/\s/g, "") || null : null;
//                 }
//             } catch {}

//             const pdfData = {
//                 reportType, fromDate, toDate, imageBase64: imageBase64 || null,
//                 entries: filteredRows.map((row) => ({
//                     srNo: row.srNo,
//                     ItemCode: row.itemCode, Description: row.description, Unit: row.unit,
//                     OpStock: Number(row.OpStock || 0), Inward: Number(row.inward || 0),
//                     Outward: Number(row.outward || 0), Closing: Number(row.closing || 0),
//                     AvgPurcRate: Number(row.avgRate || 0), PurcRate: Number(row.purcRate || 0),
//                     LastPurcRate: Number(row.lastPurcRate || 0), StockValuation: Number(row.stockValuation || 0),
//                     MinLevel: Number(row.minLevel || 0), ShortageQty: Number(row.shortageQty || 0),
//                     MaxLevel: Number(row.maxLevel || 0), ExcessQty: Number(row.excessQty || 0),
//                     GroupName: row.groupName || "",
//                 })),
//             };

//             const companyHeader = selectedCompany ? {
//                 CompId: companyId,
//                 CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
//                 Address: selectedCompany.Address || selectedCompany.address || "",
//                 MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
//                 GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
//                 EmailId: selectedCompany.EmailId || "",
//                 Website: selectedCompany.Website || "",
//                 imageBase64: imageBase64 || null,
//             } : null;
//             console.log(pdfData);

//             const format = getReportFormat(reportType);
//             const pdfResp = await axios.post(
//                 `${pdfString}/api/stock-pdf/${format}`,
//                 { docId: `stock-${format}-${fromDate}-${toDate}`, data: pdfData, company: companyHeader, companyIconFormat: "jpg" },
//                 { responseType: "blob" }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF");
//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

//             if (window.ReactNativeWebView) {
//                 const reader = new FileReader();
//                 reader.onloadend = () => window.ReactNativeWebView.postMessage(JSON.stringify({ type: "OPEN_PDF", base64: reader.result }));
//                 reader.readAsDataURL(blob);
//             } else {
//                 const newWin = window.open(blobUrl, "_blank");
//                 if (newWin) {
//                     newWin.focus();
//                     const timer = setInterval(() => { if (newWin.closed) { URL.revokeObjectURL(blobUrl); clearInterval(timer); } }, 1000);
//                 } else {
//                     setSnackbar({ open: true, message: "Popup blocked – please allow popups", severity: "warning" });
//                 }
//             }
//             setSnackbar({ open: true, message: "Stock PDF generated!", severity: "success" });
//         } catch (err) {
//             setSnackbar({ open: true, message: `PDF failed: ${err.message || "Unknown error"}`, severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     const fetchItemGroups = async () => {
//         if (itemGroups.length > 0) return;
//         try {
//             setItemGroupsLoading(true);
//             const res = await axios.get(`${connectionString}/api/product-get-data/api/non-primary-item-group`, { params: { companyId } });
//             setItemGroups(res.data.groups || []);
//         } catch {
//             setSnackbar({ open: true, message: "Failed to fetch item groups", severity: "error" });
//         } finally {
//             setItemGroupsLoading(false);
//         }
//     };

//     const handleOpenFilter = () => {
//         setTempFromDate(fromDate);
//         setTempToDate(toDate);
//         setTempReportType(reportType);
//         setTempShowZeroRecords(showZeroRecords);
//         setTempSelectedGroupIds(selectedGroupIds);
//         setFilterOpen(true);
//     };

//     const handleTempReportTypeChange = (val) => {
//         setTempReportType(val);
//         if (val === "Groupwise Item") fetchItemGroups();
//     };

//     const handleGroupToggle = (groupId) => {
//         setTempSelectedGroupIds((prev) => prev.includes(groupId) ? prev.filter((id) => id !== groupId) : [...prev, groupId]);
//     };

//     const handleSelectAllGroups = () => {
//         setTempSelectedGroupIds(tempSelectedGroupIds.length === itemGroups.length ? [] : itemGroups.map((g) => g.ItemGrpID));
//     };

//     const fetchStockLedger = async (itemId, itemCode, description) => {
//         try {
//             setSelectedItem({ itemId, itemCode, description });
//             setCurrentView("ledger");
//             setLedgerLoading(true);
//             const res = await axios.get(`${connectionString}/api/getStockLedger`, { params: { compId: companyId, itemId, fromDate, toDate } });
//             const data = (res.data.ledger || []).map((row, idx) => ({
//                 id: idx + 1, srNo: idx + 1, ...row,
//                 stockDate: row.stockDate ? new Date(row.stockDate).toLocaleDateString("en-IN") : null,
//                 expiryDate: row.expiryDate ? new Date(row.expiryDate).toLocaleDateString("en-IN") : null,
//                 docNo: row.docNo || null,
//                 firmName: row.firmName || null,
//                 partyId: row.partyId || null,
//             }));
//             setLedgerRows(data);
//         } catch {
//             setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
//             setCurrentView("report");
//         } finally {
//             setLedgerLoading(false);
//         }
//     };

//     const handleBackToReport = () => {
//         setCurrentView("report");
//         setLedgerRows([]);
//         setSelectedItem(null);
//     };

//     const handleLedgerExport = () => {
//         if (!ledgerRows.length) return;
//         try {
//             setLedgerExcelLoading(true);
//             const excelData = ledgerRows.map((row) => ({
//                 "Date": row.stockDate || "", "Book Name": row.bookName || "", "Doc No": row.docNo || "",
//                 "Party Name": row.firmName || "", "Op. Stock": Number(row.opStock || 0),
//                 "Inward": Number(row.stockInQty || 0), "Outward": Number(row.stockOutQty || 0),
//                 "Rate": Number(row.rate || 0), "Disc": Number(row.disc || 0), "Closing": Number(row.balance || 0),
//             }));
//             const ws = XLSX.utils.json_to_sheet(excelData);
//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, ws, "Stock Ledger");
//             const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//             saveAs(new Blob([buf], { type: "application/octet-stream" }), `Stock_Ledger_${selectedItem?.itemCode || "item"}_${fromDate}_to_${toDate}.xlsx`);
//             setSnackbar({ open: true, message: "Ledger Excel downloaded!", severity: "success" });
//         } catch {
//             setSnackbar({ open: true, message: "Failed to generate Ledger Excel", severity: "error" });
//         } finally {
//             setLedgerExcelLoading(false);
//         }
//     };

//     const fetchData = async (fd, td, rt, groupIds) => {
//         const usedFromDate    = fd || fromDate;
//         const usedToDate      = td || toDate;
//         const usedReportType  = rt || reportType;
//         if (!usedFromDate || !usedToDate) { setSnackbar({ open: true, message: "Select a date range first", severity: "warning" }); return; }
//         if (usedReportType === "Groupwise Item") {
//             const usedGroupIds = groupIds || selectedGroupIds;
//             if (!usedGroupIds || usedGroupIds.length === 0) { setSnackbar({ open: true, message: "Please select at least one group", severity: "warning" }); return; }
//         }
//         try {
//             setLoading(true);
//             const params = { compId: companyId, fromDate: usedFromDate, toDate: usedToDate, reportType: usedReportType };
//             if (usedReportType === "Groupwise Item") params.groupIds = (groupIds || selectedGroupIds).join(",");
//             const res = await axios.get(`${connectionString}/api/getStockReport`, { params });
//             const data = (res.data.details || []).map((row, idx) => {
//                 const closing  = Number(row.Closing || 0);
//                 const minLevel = Number(row.MinLevel || 0);
//                 return {
//                     id: idx + 1, srNo: idx + 1,
//                     itemId: row.Id, itemCode: row.ItemCode, description: row.Description, unit: row.Unit,
//                     OpStock: row.OpStock || 0, inward: row.Inward || 0, outward: row.Outward || 0, closing,
//                     avgRate: row.AvgPurcRate || 0, purcRate: row.PurchaseRate || row.PurcRate || 0,
//                     lastPurcRate: row.LastPurcRate || 0, stockValuation: row.StockValuation || row.AmountInRs || 0,
//                     minLevel, shortageQty: minLevel > closing ? closing - minLevel : 0,
//                     maxLevel: row.MaxLevel || 0, excessQty: row.ExcessQty || 0, groupName: row.GroupName || "",
//                 };
//             });
//             setRows(data);
//         } catch {
//             setSnackbar({ open: true, message: "Failed to fetch stock data", severity: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleGetData = async () => {
//         if (!tempFromDate || !tempToDate) { setSnackbar({ open: true, message: "Select a date range first", severity: "warning" }); return; }
//         if (tempReportType === "Groupwise Item" && tempSelectedGroupIds.length === 0) { setSnackbar({ open: true, message: "Please select at least one group", severity: "warning" }); return; }
//         setFromDate(tempFromDate); setToDate(tempToDate); setReportType(tempReportType);
//         setShowZeroRecords(tempShowZeroRecords); setSelectedGroupIds(tempSelectedGroupIds);
//         setAppliedFilters({ fromDate: tempFromDate, toDate: tempToDate, reportType: tempReportType, showZeroRecords: tempShowZeroRecords, selectedGroupIds: tempSelectedGroupIds });
//         setFilterOpen(false);
//         await fetchData(tempFromDate, tempToDate, tempReportType, tempSelectedGroupIds);
//     };

//     const handleRefresh = () => fetchData(fromDate, toDate, reportType, selectedGroupIds);

//     const buildExcelData = () => filteredRows.map((row) => {
//         const base = {
//             "Sr No": row.srNo,
//             ...(reportType === "Groupwise Item" ? { "Group": row.groupName || "" } : {}),
//             "Item Code": row.itemCode, "Description": row.description, "Unit": row.unit,
//             "Opening Stock": Number(row.OpStock || 0), "Inward": Number(row.inward || 0),
//             "Outward": Number(row.outward || 0), "Closing": Number(row.closing || 0),
//         };
//         switch (reportType) {
//             case "Average Rate":       return { ...base, "Avg. Rate": Number(row.avgRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
//             case "Purchase Rate":      return { ...base, "Purc. Rate": Number(row.purcRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
//             case "Last Purchase Rate": return { ...base, "Last Purc. Rate": Number(row.lastPurcRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
//             case "Min Level":          return { ...base, "Min Level": Number(row.minLevel || 0), "Shortage Qty": Number(row.shortageQty || 0) };
//             case "Max Level":          return { ...base, "Max Level": Number(row.maxLevel || 0), "Excess Qty": Number(row.excessQty || 0) };
//             default:                   return base;
//         }
//     });

//     const handleExport = () => {
//         if (!filteredRows.length) return;
//         try {
//             setExcelLoading(true);
//             const ws = XLSX.utils.json_to_sheet(buildExcelData());
//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, ws, "Stock Report");
//             const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//             saveAs(new Blob([buf], { type: "application/octet-stream" }), `Stock_Report_${reportType.replace(/\s+/g, "_")}_${fromDate}_to_${toDate}.xlsx`);
//             setSnackbar({ open: true, message: "Excel downloaded!", severity: "success" });
//         } catch {
//             setSnackbar({ open: true, message: "Failed to generate Excel", severity: "error" });
//         } finally {
//             setExcelLoading(false);
//         }
//     };

//     const handleClear = () => {
//         setFromDate(getTodayDate()); setToDate(getTodayDate()); setRows([]);
//         setReportType("General Stock Report"); setAppliedFilters(null);
//         setShowZeroRecords(false); setTempShowZeroRecords(false);
//         setSelectedGroupIds([]); setTempSelectedGroupIds([]);
//     };

//     // ─── DATAGRID COLUMNS ─────────────────────────────────────────────
//     const baseColumns = [
//         { field: "srNo", headerName: "#", width: 50, align: "center", headerAlign: "center" },
//         ...(reportType === "Groupwise Item" ? [{
//             field: "groupName", headerName: "Group", flex: 1, minWidth: 120,
//             renderCell: ({ value }) => (
//                 <Box sx={{ display: "inline-flex", alignItems: "center", px: "7px", height: "22px", background: FB_LIGHT, borderRadius: "6px" }}>
//                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB, lineHeight: 1 }}>{value || "—"}</Typography>
//                 </Box>
//             ),
//         }] : []),
//         {
//             field: "itemCode", headerName: "Item Code", flex: 1, minWidth: 110,
//             renderCell: ({ value, row }) => (
//                 <Typography onClick={() => fetchStockLedger(row.itemId, row.itemCode, row.description)}
//                     sx={{ fontSize: 13, fontWeight: 600, color: FB, cursor: "pointer", textDecoration: "underline", "&:hover": { color: FB_DARK } }}>
//                     {value}
//                 </Typography>
//             ),
//         },
//         {
//             field: "description", headerName: "Description", flex: 2, minWidth: 160,
//             renderCell: ({ value }) => (
//                 <Typography sx={{ fontSize: 13, color: G900, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>{value}</Typography>
//             ),
//         },
//         {
//             field: "unit", headerName: "Unit", width: 80,
//             renderCell: ({ value }) => value ? (
//                 <Box sx={{ display: "inline-flex", alignItems: "center", px: "7px", height: "22px", background: FB_LIGHT, borderRadius: "6px" }}>
//                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB, lineHeight: 1 }}>{value}</Typography>
//                 </Box>
//             ) : <Typography sx={{ fontSize: 13, color: G500 }}>—</Typography>,
//         },
//         {
//             field: "OpStock", headerName: "Op. Stock", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
//             renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography>,
//         },
//         {
//             field: "inward", headerName: "Inward", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
//             renderCell: ({ value }) => (
//                 <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? FB : G500 }}>{fmt(value)}</Typography>
//             ),
//         },
//         {
//             field: "outward", headerName: "Outward", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
//             renderCell: ({ value }) => (
//                 <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? G700 : G500 }}>{fmt(value)}</Typography>
//             ),
//         },
//         {
//             field: "closing", headerName: "Closing", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
//             renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(value)}</Typography>,
//         },
//     ];

//     const getExtraColumns = () => {
//         const extraColor = G900;
//         switch (reportType) {
//             case "Average Rate":
//                 return [
//                     { field: "avgRate",        headerName: "Avg. Rate",     flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                     { field: "stockValuation", headerName: "Amount (Rs.)",  flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                 ];
//             case "Purchase Rate":
//                 return [
//                     { field: "purcRate",       headerName: "Purc. Rate",    flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                     { field: "stockValuation", headerName: "Amount (Rs.)",  flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                 ];
//             case "Last Purchase Rate":
//                 return [
//                     { field: "lastPurcRate",   headerName: "Last Purc. Rate", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                     { field: "stockValuation", headerName: "Amount (Rs.)",    flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                 ];
//             case "Min Level":
//                 return [
//                     { field: "minLevel",    headerName: "Min Level",    flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                     { field: "shortageQty", headerName: "Shortage Qty", flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                 ];
//             case "Max Level":
//                 return [
//                     { field: "maxLevel",  headerName: "Max Level",  flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                     { field: "excessQty", headerName: "Excess Qty", flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
//                 ];
//             default: return [];
//         }
//     };

//     const columns = (reportType === "General Stock Report" || reportType === "Groupwise Item") ? baseColumns : [...baseColumns, ...getExtraColumns()];

//     // ─── LEDGER COLUMNS ───────────────────────────────────────────────
//     const ledgerColumns = [
//         { field: "srNo", headerName: "#", width: 50, align: "center", headerAlign: "center" },
//         { field: "stockDate", headerName: "Date",      width: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{value || "—"}</Typography> },
//         {
//             field: "bookName", headerName: "Book Name", width: 100,
//             renderCell: ({ value }) => (
//                 <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px" }}>
//                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{value}</Typography>
//                 </Box>
//             ),
//         },
//         { field: "docNo",    headerName: "Doc No",     width: 150, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{value || "—"}</Typography> },
//         { field: "firmName", headerName: "Party Name", flex: 1, minWidth: 110, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>{value || "—"}</Typography> },
//         { field: "opStock",     headerName: "Op. Stock", width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography> },
//         { field: "stockInQty",  headerName: "Inward",    width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? FB : G500 }}>{fmt(value)}</Typography> },
//         { field: "stockOutQty", headerName: "Outward",   width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? G700 : G500 }}>{fmt(value)}</Typography> },
//         { field: "rate",   headerName: "Rate",    width: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography> },
//         { field: "disc",   headerName: "Disc",    width: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: Number(value) ? G700 : G500, fontWeight: Number(value) ? 600 : 400 }}>{fmt(value)}</Typography> },
//         { field: "balance", headerName: "Closing", width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(value)}</Typography> },
//     ];

//     // ─── TOTALS BAR DATA ──────────────────────────────────────────────
//     const getTotalsItems = () => {
//         const base = [
//             { label: "Op. Bal", value: fmt(totOp),  color: G900 },
//             { label: "Inward",  value: fmt(totIn),  color: FB   },
//             { label: "Outward", value: fmt(totOut), color: G700 },
//             { label: "Closing", value: fmt(totCl),  color: FB   },
//         ];
//         if (reportType === "Average Rate")
//             return [...base, { label: "Avg. Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.avgRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
//         if (reportType === "Purchase Rate")
//             return [...base, { label: "Purc. Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.purcRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
//         if (reportType === "Last Purchase Rate")
//             return [...base, { label: "Last Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.lastPurcRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
//         if (reportType === "Min Level")
//             return [...base, { label: "Min Level", value: fmt(filteredRows.reduce((s, r) => s + Number(r.minLevel || 0), 0)), color: G900 }, { label: "Shortage", value: fmt(filteredRows.reduce((s, r) => s + Number(r.shortageQty || 0), 0)), color: G700 }];
//         if (reportType === "Max Level")
//             return [...base, { label: "Max Level", value: fmt(filteredRows.reduce((s, r) => s + Number(r.maxLevel || 0), 0)), color: G900 }, { label: "Excess", value: fmt(filteredRows.reduce((s, r) => s + Number(r.excessQty || 0), 0)), color: G900 }];
//         return base;
//     };

//     // ─── ENTERPRISE PAGE HEADER ───────────────────────────────────────
//     const pageHeader = (title, subtitle, actions) => (
//         <Box sx={{ background: NAVY, display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, minHeight: 56, flexShrink: 0, gap: 2 }}>
//             <Box sx={{ width: 30, height: 30, borderRadius: "4px", background: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                 <BarChartIcon sx={{ fontSize: 17, color: WHITE }} />
//             </Box>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//                 <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1.2 }}>{title}</Typography>
//                 {subtitle && <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "2px" }}>{subtitle}</Typography>}
//             </Box>
//             <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexShrink: 0 }}>{actions}</Box>
//         </Box>
//     );

//     // ─── RENDER ───────────────────────────────────────────────────────
//     return (
//         <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>

//             {currentView === "report" ? (
//                 <>
//                     {/* ── HEADER ── */}
//                     {pageHeader(
//                         "Stock Report",
//                         appliedFilters ? `${filteredRows.length} items · ${appliedFilters.fromDate} – ${appliedFilters.toDate}` : "Inventory movement & valuation",
//                         <>
//                             {appliedFilters && (
//                                 <Button onClick={handleRefresh} disabled={loading}
//                                     startIcon={loading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <RefreshIcon sx={{ fontSize: 14 }} />}
//                                     sx={btnHeaderGhost}>
//                                     {isMobile ? "" : "Refresh"}
//                                 </Button>
//                             )}
//                             {filteredRows.length > 0 && (
//                                 <>
//                                     <Button onClick={handleExport} disabled={excelLoading}
//                                         startIcon={excelLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
//                                         sx={btnHeaderGhost}>
//                                         {isMobile ? "Excel" : "Export Excel"}
//                                     </Button>
//                                     <Button onClick={handleStockPdf} disabled={pdfLoading}
//                                         startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
//                                         sx={btnHeaderGhost}>
//                                         {isMobile ? "PDF" : "Generate PDF"}
//                                     </Button>
//                                 </>
//                             )}
//                             <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
//                                 {isMobile ? "Filter" : "Configure Report"}
//                             </Button>
//                         </>
//                     )}

//                     {/* ── KPI SUMMARY CARDS ── */}
//                     {filteredRows.length > 0 && (
//                         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: `repeat(${Math.min(getTotalsItems().length, 5)}, 1fr)` }, gap: { xs: 1, sm: 1.5 }, px: { xs: 1.5, sm: 2 }, pt: { xs: 1.5, sm: 2 }, pb: 0 }}>
//                             {getTotalsItems().map(({ label, value, color }) => (
//                                 <Box key={label} sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", p: "12px 14px", borderLeft: `3px solid ${color === POS || color === FB ? STEEL : NAVY}` }}>
//                                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".7px", mb: "8px" }}>{label}</Typography>
//                                     <Typography sx={{ fontSize: 16, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>{value}</Typography>
//                                 </Box>
//                             ))}
//                         </Box>
//                     )}

//                     {/* ── CONTENT CARD ── */}
//                     <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
//                         <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>
//                             {/* Active filter status bar */}
//                             {appliedFilters && (
//                                 <Box sx={{ px: { xs: 1.5, sm: 2 }, py: "9px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: TH_BG, borderBottom: `1px solid ${BORDER}` }}>
//                                     <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
//                                         <Typography sx={{ fontSize: 10, color: T3, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", mr: 0.5 }}>Active Filters:</Typography>
//                                         {[
//                                             appliedFilters.reportType,
//                                             `${appliedFilters.fromDate} – ${appliedFilters.toDate}`,
//                                             ...(appliedFilters.reportType === "Groupwise Item" && appliedFilters.selectedGroupIds?.length > 0 ? [`${appliedFilters.selectedGroupIds.length} group${appliedFilters.selectedGroupIds.length > 1 ? "s" : ""}`] : []),
//                                             ...(appliedFilters.showZeroRecords ? ["Zero items shown"] : []),
//                                         ].map(tag => (
//                                             <Box key={tag} sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
//                                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{tag}</Typography>
//                                             </Box>
//                                         ))}
//                                         <Box sx={{ px: 1, py: "2px", background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "3px", display: "flex", alignItems: "center", gap: 0.5 }}>
//                                             <Inventory2OutlinedIcon sx={{ fontSize: 12, color: T3 }} />
//                                             <Typography sx={{ fontSize: 11, fontWeight: 600, color: T1 }}>{filteredRows.length} items</Typography>
//                                         </Box>
//                                     </Box>
//                                     <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 11 }} />} sx={btnGhost}>
//                                         Clear
//                                     </Button>
//                                 </Box>
//                             )}

//                             {loading ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: "3rem" }}>
//                                     <CircularProgress size={22} sx={{ color: STEEL }} />
//                                     <Typography sx={{ fontSize: 13, color: T3 }}>Loading stock data…</Typography>
//                                 </Box>

//                             ) : !appliedFilters ? (
//                                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "4rem", gap: 2 }}>
//                                     <BarChartIcon sx={{ fontSize: 36, color: T3 }} />
//                                     <Box sx={{ textAlign: "center" }}>
//                                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: T1, mb: "4px" }}>No Report Selected</Typography>
//                                         <Typography sx={{ fontSize: 12, color: T3 }}>Configure report type &amp; date range to get started</Typography>
//                                     </Box>
//                                     <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnPrimary}>Configure & Run Report</Button>
//                                 </Box>

//                             ) : filteredRows.length === 0 ? (
//                                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 1 }}>
//                                     <BarChartIcon sx={{ fontSize: 30, color: BORDER }} />
//                                     <Typography sx={{ fontSize: 14, fontWeight: 600, color: T1 }}>No data found</Typography>
//                                     <Typography sx={{ fontSize: 12, color: T3 }}>Try changing the date range or report type</Typography>
//                                 </Box>

//                             ) : isMobile ? (
//                                 <Box sx={{ p: 1.25 }}>
//                                     {filteredRows.map((row) => <MobileCard key={row.id} row={row} fmt={fmt} reportType={reportType} />)}
//                                     <Box sx={{ display: "flex", justifyContent: "space-between", pt: 1, px: 0.5 }}>
//                                         <Typography sx={{ fontSize: 12, color: G500 }}>{filteredRows.length} items</Typography>
//                                         <Typography sx={{ fontSize: 12, color: G500 }}>{fromDate} → {toDate}</Typography>
//                                     </Box>
//                                 </Box>

//                             ) : (
//                                 <>
//                                     <DataGrid
//                                         rows={filteredRows} columns={columns}
//                                         autoHeight rowHeight={40}
//                                         disableRowSelectionOnClick hideFooterSelectedRowCount
//                                         pageSizeOptions={[25, 50, 100]}
//                                         initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
//                                         sx={dgSx}
//                                     />
//                                     {/* Totals footer */}
//                                     <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
//                                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
//                                             {filteredRows.length} items
//                                         </Typography>
//                                         <Box sx={{ display: "flex", gap: { xs: 2, sm: 4 }, ml: "auto", flexWrap: "wrap" }}>
//                                             {getTotalsItems().map(({ label, value }) => (
//                                                 <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
//                                                     <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
//                                                     <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums" }}>{value}</Typography>
//                                                 </Box>
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 </>
//                             )}
//                         </Box>
//                     </Box>
//                 </>

//             ) : (
//                 <>
//                     {/* ── LEDGER HEADER ── */}
//                     {pageHeader(
//                         "Stock Ledger",
//                         selectedItem ? `Stock Report › ${selectedItem.itemCode} · ${selectedItem.description}` : "",
//                         <>
//                             <Button onClick={handleBackToReport} startIcon={<ArrowBackIcon sx={{ fontSize: 14 }} />} sx={btnHeaderGhost}>
//                                 Back to Report
//                             </Button>
//                             {ledgerRows.length > 0 && (
//                                 <>
//                                     <Button onClick={handleLedgerExport} disabled={ledgerExcelLoading}
//                                         startIcon={ledgerExcelLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
//                                         sx={btnHeaderGhost}>
//                                         {isMobile ? "Excel" : "Export Excel"}
//                                     </Button>
//                                     <Button
//                                         onClick={async () => {
//                                             setPdfLoading(true);
//                                             try {
//                                                 let imageBase64 = null;
//                                                 try {
//                                                     const iconRes = await axios.get(`${connectionString}/company/GetIcon/${encodeURIComponent(companyId)}`);
//                                                     if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                                                         const raw = iconRes.data.imageBase64;
//                                                         imageBase64 = typeof raw === "string" ? raw.split("base64,").pop()?.replace(/\s/g, "") || null : null;
//                                                     }
//                                                 } catch {}
//                                                 const pdfData = {
//                                                     fromDate, toDate, imageBase64: imageBase64 || null,
//                                                     entries: ledgerRows.map((row) => ({
//                                                         stockDate: row.stockDate || "", bookName: row.bookName || "", docNo: row.docNo || "",
//                                                         firmName: row.firmName || "", opStock: Number(row.opStock || 0),
//                                                         stockInQty: Number(row.stockInQty || 0), stockOutQty: Number(row.stockOutQty || 0),
//                                                         rate: Number(row.rate || 0), disc: Number(row.disc || 0), balance: Number(row.balance || 0),
//                                                         itemCode: selectedItem?.itemCode || "", description: selectedItem?.description || "", unit: row.unit || "",
//                                                     })),
//                                                 };
//                                                 const companyHeader = selectedCompany ? {
//                                                     CompId: companyId,
//                                                     CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
//                                                     Address: selectedCompany.Address || selectedCompany.address || "",
//                                                     MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
//                                                     GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
//                                                     EmailId: selectedCompany.EmailId || "",
//                                                     Website: selectedCompany.Website || "",
//                                                     imageBase64: imageBase64 || null,
//                                                 } : null;
//                                                 const pdfResp = await axios.post(
//                                                     `${pdfString}/api/stock-pdf/format_8`,
//                                                     { docId: `stock-format_8-${fromDate}-${toDate}`, data: pdfData, company: companyHeader, companyIconFormat: "jpg" },
//                                                     { responseType: "blob" }
//                                                 );
//                                                 const blob = pdfResp.data;
//                                                 if (!blob || blob.size === 0) throw new Error("Empty PDF");
//                                                 const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
//                                                 if (window.ReactNativeWebView) {
//                                                     const reader = new FileReader();
//                                                     reader.onloadend = () => window.ReactNativeWebView.postMessage(JSON.stringify({ type: "OPEN_PDF", base64: reader.result }));
//                                                     reader.readAsDataURL(blob);
//                                                 } else {
//                                                     const newWin = window.open(blobUrl, "_blank");
//                                                     if (newWin) {
//                                                         newWin.focus();
//                                                         const timer = setInterval(() => { if (newWin.closed) { URL.revokeObjectURL(blobUrl); clearInterval(timer); } }, 1000);
//                                                     } else {
//                                                         setSnackbar({ open: true, message: "Popup blocked – allow popups", severity: "warning" });
//                                                     }
//                                                 }
//                                                 setSnackbar({ open: true, message: "PDF generated!", severity: "success" });
//                                             } catch (err) {
//                                                 setSnackbar({ open: true, message: `PDF failed: ${err.message || "Unknown error"}`, severity: "error" });
//                                             } finally {
//                                                 setPdfLoading(false);
//                                             }
//                                         }}
//                                         disabled={pdfLoading}
//                                         startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
//                                         sx={btnHeaderGhost}>
//                                         {isMobile ? "PDF" : "Generate PDF"}
//                                     </Button>
//                                 </>
//                             )}
//                         </>
//                     )}

//                     {/* Ledger context bar */}
//                     <Box sx={{ background: TH_BG, borderBottom: `1px solid ${BORDER}`, px: { xs: 2, sm: 3 }, py: "8px", display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0, flexWrap: "wrap" }}>
//                         <Box sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{fromDate} – {toDate}</Typography>
//                         </Box>
//                         {ledgerRows.length > 0 && (
//                             <Box sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{ledgerRows.length} entries</Typography>
//                             </Box>
//                         )}
//                     </Box>

//                     {/* ── LEDGER CONTENT ── */}
//                     <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
//                         <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>
//                             {ledgerLoading ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: "3rem" }}>
//                                     <CircularProgress size={22} sx={{ color: STEEL }} />
//                                     <Typography sx={{ fontSize: 13, color: T3 }}>Loading ledger…</Typography>
//                                 </Box>
//                             ) : ledgerRows.length === 0 ? (
//                                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 1 }}>
//                                     <BarChartIcon sx={{ fontSize: 30, color: BORDER }} />
//                                     <Typography sx={{ fontSize: 14, fontWeight: 600, color: T1 }}>No ledger entries found</Typography>
//                                     <Typography sx={{ fontSize: 12, color: T3 }}>No stock movements for this item in the selected period</Typography>
//                                 </Box>
//                             ) : isMobile ? (
//                                 <Box sx={{ p: 1.25 }}>
//                                     {ledgerRows.map((row) => <MobileLedgerCard key={row.id} row={row} fmt={fmt} />)}
//                                 </Box>
//                             ) : (
//                                 <>
//                                     <DataGrid
//                                         rows={ledgerRows} columns={ledgerColumns}
//                                         autoHeight rowHeight={40}
//                                         disableRowSelectionOnClick hideFooterSelectedRowCount
//                                         pageSizeOptions={[25, 50, 100]}
//                                         initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
//                                         sx={dgSx}
//                                     />
//                                     {/* Ledger totals footer */}
//                                     <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
//                                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
//                                             {ledgerRows.length} entries
//                                         </Typography>
//                                         <Box sx={{ display: "flex", gap: { xs: 2, sm: 4 }, ml: "auto", flexWrap: "wrap" }}>
//                                             {[
//                                                 { label: "Inward",  value: fmt(ledgerRows.reduce((s, r) => s + Number(r.stockInQty  || 0), 0)) },
//                                                 { label: "Outward", value: fmt(ledgerRows.reduce((s, r) => s + Number(r.stockOutQty || 0), 0)) },
//                                                 { label: "Closing", value: fmt(ledgerRows.length ? Number(ledgerRows[ledgerRows.length - 1].balance || 0) : 0) },
//                                             ].map(({ label, value }) => (
//                                                 <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
//                                                     <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
//                                                     <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums" }}>{value}</Typography>
//                                                 </Box>
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 </>
//                             )}
//                         </Box>
//                     </Box>
//                 </>
//             )}

//             {/* ── REPORT CONFIGURATION DIALOG ── */}
//             <StockReportFilterDialog
//                 open={filterOpen}
//                 onClose={() => setFilterOpen(false)}
//                 loading={loading}
//                 tempReportType={tempReportType}
//                 handleTempReportTypeChange={handleTempReportTypeChange}
//                 reportOptions={reportOptions}
//                 tempSelectedGroupIds={tempSelectedGroupIds}
//                 itemGroups={itemGroups}
//                 itemGroupsLoading={itemGroupsLoading}
//                 handleSelectAllGroups={handleSelectAllGroups}
//                 handleGroupToggle={handleGroupToggle}
//                 tempFromDate={tempFromDate}
//                 setTempFromDate={setTempFromDate}
//                 tempToDate={tempToDate}
//                 setTempToDate={setTempToDate}
//                 tempShowZeroRecords={tempShowZeroRecords}
//                 setTempShowZeroRecords={setTempShowZeroRecords}
//                 onGetData={handleGetData}
//             />

//             {/* ── SNACKBAR ── */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//                 <Alert severity={snackbar.severity} variant="filled" onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }










import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Snackbar, Alert, CircularProgress, TextField, Grid, useTheme, useMediaQuery } from "@mui/material";
import StockReportFilterDialog from "./StockReportFilterDialog";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import useDataLoadingState from "../hooks/useDataLoadingState";
import LoadingSpinner from "../components/Common/LoadingSpinner";
import BarChartIcon from '@mui/icons-material/BarChart';
import ClearIcon from '@mui/icons-material/Clear';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import TuneIcon from '@mui/icons-material/Tune';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// ─── ENTERPRISE ERP DESIGN TOKENS ─────────────────────────────────────
const NAVY     = "#0D2137";
const STEEL    = "#1B4FBB";
const STEEL_LT = "#EBF2FF";
const PAGE_BG  = "#F4F6F9";
const CARD     = "#FFFFFF";
const BORDER   = "#E2E8F0";
const TH_BG    = "#F7F9FC";
const T1       = "#1A202C";
const T2       = "#4A5568";
const T3       = "#718096";
const POS      = "#276749";
const WHITE    = "#FFFFFF";
// Legacy aliases (used in StatCard / MobileCard helpers below)
const FB       = STEEL;
const FB_LIGHT = STEEL_LT;
const FB_DARK = NAVY;
const G200     = "#EEEEEE";
const G300     = BORDER;
const G500     = T3;
const G700     = T2;
const G900     = T1;

// ─── SHARED SX HELPERS ────────────────────────────────────────────────
const cardSx = {
    background: CARD,
    border: `1px solid ${BORDER}`,
    borderRadius: "6px",
    p: { xs: 1.5, sm: 2 },
};
const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px", background: WHITE, fontSize: 13, height: 36,
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: STEEL },
        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
    },
    "& .MuiInputLabel-root": { fontSize: 13, color: T3 },
};
const btnPrimary = {
    background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
    textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
    "&:hover": { background: "#1640A0" },
    "&:disabled": { background: BORDER, color: T3 },
};
const btnOutline = {
    background: "transparent", color: STEEL, border: `1px solid ${BORDER}`,
    borderRadius: "4px", fontSize: 12, fontWeight: 500,
    textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
    "&:hover": { background: STEEL_LT },
};
const btnGhost = {
    background: "transparent", color: T2, border: `1px solid ${BORDER}`,
    borderRadius: "4px", fontSize: 12, fontWeight: 500,
    textTransform: "none", px: 1.5, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: PAGE_BG, color: T1 },
};
const btnHeaderGhost = {
    color: "rgba(255,255,255,0.88)", border: "1px solid rgba(255,255,255,0.25)",
    background: "transparent", borderRadius: "4px", fontSize: 12, fontWeight: 500,
    textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: "rgba(255,255,255,0.1)" },
    "&:disabled": { color: "rgba(255,255,255,0.3)" },
};
const btnHeaderSolid = {
    color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
    textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: "#E8EDF5" },
};
const dgSx = {
    border: "none",
    "& .MuiDataGrid-columnHeaders": { background: TH_BG, borderBottom: `1px solid ${BORDER}` },
    "& .MuiDataGrid-columnHeaderTitle": { fontSize: 11, fontWeight: 700, color: T2, letterSpacing: ".5px", textTransform: "uppercase" },
    "& .MuiDataGrid-cell": { borderBottom: `1px solid ${BORDER}`, outline: "none !important", display: "flex", alignItems: "center" },
    "& .MuiDataGrid-row:hover": { background: STEEL_LT },
    "& .MuiDataGrid-row:nth-of-type(even)": { background: "#FAFBFD" },
    "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${BORDER}`, background: TH_BG },
    "& .MuiTablePagination-root": { fontSize: 12, color: T2 },
};

// ─── STAT CARD ────────────────────────────────────────────────────────
function StatCard({ label, value, icon }) {
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", p: "12px 14px", flex: 1, minWidth: 0 }}>
            <Box sx={{ width: 34, height: 34, borderRadius: "9px", background: FB_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 11, color: G500, fontWeight: 500, mb: "2px" }}>{label}</Typography>
                <Typography sx={{ fontSize: 15, fontWeight: 600, color: G900 }} noWrap>{value}</Typography>
            </Box>
        </Box>
    );
}

// ─── MOBILE ITEM CARD ─────────────────────────────────────────────────
function MobileCard({ row, fmt, reportType }) {
    return (
        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: "12px", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1 }}>
                <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{row.itemCode}</Typography>
                    <Typography sx={{ fontSize: 12, color: G500, mt: "1px" }} noWrap>{row.description}</Typography>
                </Box>
                <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px", flexShrink: 0, ml: 1 }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{row.unit}</Typography>
                </Box>
            </Box>
            <Grid container spacing={0.75}>
                {reportType !== "General Stock Report" ? (
                    <>
                        {[
                            { k: "Op. Stock",   v: row.OpStock,         c: G900 },
                            { k: "Inward",      v: row.inward,          c: FB   },
                            { k: "Outward",     v: row.outward,         c: G700 },
                            { k: "Closing",     v: row.closing,         c: FB   },
                            { k: "Avg. Rate",   v: row.avgRate,         c: G900 },
                            { k: "Amount (Rs.)",v: row.stockValuation,  c: G900 },
                        ].map(({ k, v, c }) => (
                            <Grid item xs={6} key={k}>
                                <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
                                    <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </>
                ) : (
                    <>
                        {[
                            { k: "Op. Stock", v: row.OpStock,  c: G900 },
                            { k: "Inward",    v: row.inward,   c: FB   },
                            { k: "Outward",   v: row.outward,  c: G700 },
                            { k: "Closing",   v: row.closing,  c: FB   },
                        ].map(({ k, v, c }) => (
                            <Grid item xs={6} key={k}>
                                <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
                                    <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </>
                )}
            </Grid>
        </Box>
    );
}

// ─── MOBILE LEDGER CARD ───────────────────────────────────────────────
function MobileLedgerCard({ row, fmt }) {
    return (
        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: "12px", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1 }}>
                <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{row.stockDate}</Typography>
                    <Typography sx={{ fontSize: 12, color: G500, mt: "1px" }} noWrap>{row.docNo || "—"}</Typography>
                </Box>
                <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px", flexShrink: 0, ml: 1 }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{row.bookName}</Typography>
                </Box>
            </Box>
            <Grid container spacing={0.75}>
                {[
                    { k: "Op. Stock", v: row.opStock,     c: G900 },
                    { k: "Inward",    v: row.stockInQty,  c: FB   },
                    { k: "Outward",   v: row.stockOutQty, c: G700 },
                    { k: "Closing",   v: row.balance,     c: FB   },
                    { k: "Rate",      v: row.rate,         c: G900 },
                    { k: "Disc",      v: row.disc,         c: G700 },
                ].map(({ k, v, c }) => (
                    <Grid item xs={6} key={k}>
                        <Box sx={{ background: G200, borderRadius: "7px", p: "6px 8px" }}>
                            <Typography sx={{ fontSize: 11, color: G500, mb: "2px" }}>{k}</Typography>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: c }}>{fmt(v)}</Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────
export default function StockReport({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const { user, selectedCompany } = useAuth();
    const companyId = selectedCompany?.CompId;
    const getTodayDate = () => new Date().toISOString().split("T")[0];
    const getFinancialYearDates = () => {
        const today = new Date();
        const yr = today.getFullYear();
        const fyStart = new Date(yr, 3, 2);
        if (today < fyStart) fyStart.setFullYear(yr - 1);
        const fyEnd = new Date(fyStart.getFullYear() + 1, 2, 32);
        return { fromDate: fyStart.toISOString().split("T")[0], toDate: fyEnd.toISOString().split("T")[0] };
    };

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);

    const [fromDate, setFromDate] = useState(getTodayDate());
    const [toDate, setToDate] = useState(getTodayDate());
    const [reportType, setReportType] = useState("General Stock Report");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const [filterOpen, setFilterOpen] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [showZeroRecords, setShowZeroRecords] = useState(false);
    const [tempShowZeroRecords, setTempShowZeroRecords] = useState(false);

    const fy = getFinancialYearDates();
    const [tempFromDate, setTempFromDate] = useState(fy.fromDate);
    const [tempToDate, setTempToDate] = useState(fy.toDate);
    const [tempReportType, setTempReportType] = useState("General Stock Report");

    const [currentView, setCurrentView] = useState("report");
    const [ledgerRows, setLedgerRows] = useState([]);
    const [ledgerLoading, setLedgerLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [ledgerExcelLoading, setLedgerExcelLoading] = useState(false);

    const [itemGroups, setItemGroups] = useState([]);
    const [itemGroupsLoading, setItemGroupsLoading] = useState(false);
    const [selectedGroupIds, setSelectedGroupIds] = useState([]);
    const [tempSelectedGroupIds, setTempSelectedGroupIds] = useState([]);

    const [pdfLoading, setPdfLoading] = useState(false);

    const fmt = (n) => Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const filteredRows = (showZeroRecords
        ? rows
        : rows.filter((r) => !(Number(r.OpStock || 0) === 0 && Number(r.inward || 0) === 0 && Number(r.outward || 0) === 0))
    ).map((r, idx) => ({ ...r, srNo: idx + 1 }));

    const totOp  = filteredRows.reduce((s, r) => s + Number(r.OpStock || 0), 0);
    const totIn  = filteredRows.reduce((s, r) => s + Number(r.inward  || 0), 0);
    const totOut = filteredRows.reduce((s, r) => s + Number(r.outward || 0), 0);
    const totCl  = filteredRows.reduce((s, r) => s + Number(r.closing || 0), 0);
    const totStockVal = filteredRows.reduce((s, r) => s + Number(r.stockValuation || 0), 0);

    const reportOptions = [
        "General Stock Report",
        "Average Rate",
        "Purchase Rate",
        "Last Purchase Rate",
        "Min Level",
        "Max Level",
        "Groupwise Item",
    ];

    const getReportFormat = (type) => ({
        "General Stock Report": "format_1",
        "Average Rate":         "format_2",
        "Purchase Rate":        "format_3",
        "Last Purchase Rate":   "format_4",
        "Min Level":            "format_5",
        "Max Level":            "format_6",
        "Groupwise Item":       "format_7",
    }[type] || "format_1");

    // ─── STOCK PDF ────────────────────────────────────────────────────────
    const handleStockPdf = async () => {
        if (!filteredRows.length) return;
        setPdfLoading(true);
        try {
            let imageBase64 = null;
            try {
                const iconRes = await axios.get(`${connectionString}/company/GetIcon/${encodeURIComponent(companyId)}`);
                if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                    const raw = iconRes.data.imageBase64;
                    imageBase64 = typeof raw === "string" ? raw.split("base64,").pop()?.replace(/\s/g, "") || null : null;
                }
            } catch {}

            const pdfData = {
                reportType, fromDate, toDate, imageBase64: imageBase64 || null,
                entries: filteredRows.map((row) => ({
                    srNo: row.srNo,
                    ItemCode: row.itemCode, Description: row.description, Unit: row.unit,
                    OpStock: Number(row.OpStock || 0), Inward: Number(row.inward || 0),
                    Outward: Number(row.outward || 0), Closing: Number(row.closing || 0),
                    AvgPurcRate: Number(row.avgRate || 0), PurcRate: Number(row.purcRate || 0),
                    LastPurcRate: Number(row.lastPurcRate || 0), StockValuation: Number(row.stockValuation || 0),
                    MinLevel: Number(row.minLevel || 0), ShortageQty: Number(row.shortageQty || 0),
                    MaxLevel: Number(row.maxLevel || 0), ExcessQty: Number(row.excessQty || 0),
                    GroupName: row.groupName || "",
                })),
            };

            const companyHeader = selectedCompany ? {
                CompId: companyId,
                CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
                Address: selectedCompany.Address || selectedCompany.address || "",
                MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
                GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
                EmailId: selectedCompany.EmailId || "",
                Website: selectedCompany.Website || "",
                imageBase64: imageBase64 || null,
            } : null;
            console.log(pdfData);

            const format = getReportFormat(reportType);
            const pdfResp = await axios.post(
                `${pdfString}/api/stock-pdf/${format}`,
                { docId: `stock-${format}-${fromDate}-${toDate}`, data: pdfData, company: companyHeader, companyIconFormat: "jpg" },
                { responseType: "blob" }
            );

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");
            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            if (window.ReactNativeWebView) {
                const reader = new FileReader();
                reader.onloadend = () => window.ReactNativeWebView.postMessage(JSON.stringify({ type: "OPEN_PDF", base64: reader.result }));
                reader.readAsDataURL(blob);
            } else {
                const newWin = window.open(blobUrl, "_blank");
                if (newWin) {
                    newWin.focus();
                    const timer = setInterval(() => { if (newWin.closed) { URL.revokeObjectURL(blobUrl); clearInterval(timer); } }, 1000);
                } else {
                    setSnackbar({ open: true, message: "Popup blocked – please allow popups", severity: "warning" });
                }
            }
            setSnackbar({ open: true, message: "Stock PDF generated!", severity: "success" });
        } catch (err) {
            setSnackbar({ open: true, message: `PDF failed: ${err.message || "Unknown error"}`, severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    const fetchItemGroups = async () => {
        if (itemGroups.length > 0) return;
        try {
            setItemGroupsLoading(true);
            const res = await axios.get(`${connectionString}/api/product-get-data/api/non-primary-item-group`, { params: { companyId } });
            setItemGroups(res.data.groups || []);
        } catch {
            setSnackbar({ open: true, message: "Failed to fetch item groups", severity: "error" });
        } finally {
            setItemGroupsLoading(false);
        }
    };

    const handleOpenFilter = (overrideReportType) => {
        const rt = typeof overrideReportType === "string" ? overrideReportType : null;
        const resolvedType = rt || reportType;
        setTempFromDate(fromDate);
        setTempToDate(toDate);
        setTempReportType(resolvedType);
        setTempShowZeroRecords(showZeroRecords);
        setTempSelectedGroupIds(selectedGroupIds);
        if (resolvedType === "Groupwise Item") fetchItemGroups();
        setFilterOpen(true);
    };

    // Mirrors OSandODSaleReport effect 1: keep reportType in sync with the
    // sidebar selection so "Configure Report" always re-opens on the right type.
    useEffect(() => {
        if (initialReportType) {
            setReportType(initialReportType);
        }
    }, [initialReportType]);

    useEffect(() => {
        if (openFilterTrigger > 0) {
            handleOpenFilter(initialReportType);
        }
    }, [openFilterTrigger, initialReportType]);

    const handleTempReportTypeChange = (val) => {
        setTempReportType(val);
        if (val === "Groupwise Item") fetchItemGroups();
    };

    const handleGroupToggle = (groupId) => {
        setTempSelectedGroupIds((prev) => prev.includes(groupId) ? prev.filter((id) => id !== groupId) : [...prev, groupId]);
    };

    const handleSelectAllGroups = () => {
        setTempSelectedGroupIds(tempSelectedGroupIds.length === itemGroups.length ? [] : itemGroups.map((g) => g.ItemGrpID));
    };

    const fetchStockLedger = async (itemId, itemCode, description) => {
        try {
            setSelectedItem({ itemId, itemCode, description });
            setCurrentView("ledger");
            setLedgerLoading(true);
            const res = await axios.get(`${connectionString}/api/getStockLedger`, { params: { compId: companyId, itemId, fromDate, toDate } });
            const data = (res.data.ledger || []).map((row, idx) => ({
                id: idx + 1, srNo: idx + 1, ...row,
                stockDate: row.stockDate ? new Date(row.stockDate).toLocaleDateString("en-IN") : null,
                expiryDate: row.expiryDate ? new Date(row.expiryDate).toLocaleDateString("en-IN") : null,
                docNo: row.docNo || null,
                firmName: row.firmName || null,
                partyId: row.partyId || null,
            }));
            setLedgerRows(data);
        } catch {
            setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
            setCurrentView("report");
        } finally {
            setLedgerLoading(false);
        }
    };

    const handleBackToReport = () => {
        setCurrentView("report");
        setLedgerRows([]);
        setSelectedItem(null);
    };

    const handleLedgerExport = () => {
        if (!ledgerRows.length) return;
        try {
            setLedgerExcelLoading(true);
            const excelData = ledgerRows.map((row) => ({
                "Date": row.stockDate || "", "Book Name": row.bookName || "", "Doc No": row.docNo || "",
                "Party Name": row.firmName || "", "Op. Stock": Number(row.opStock || 0),
                "Inward": Number(row.stockInQty || 0), "Outward": Number(row.stockOutQty || 0),
                "Rate": Number(row.rate || 0), "Disc": Number(row.disc || 0), "Closing": Number(row.balance || 0),
            }));
            const ws = XLSX.utils.json_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Stock Ledger");
            const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([buf], { type: "application/octet-stream" }), `Stock_Ledger_${selectedItem?.itemCode || "item"}_${fromDate}_to_${toDate}.xlsx`);
            setSnackbar({ open: true, message: "Ledger Excel downloaded!", severity: "success" });
        } catch {
            setSnackbar({ open: true, message: "Failed to generate Ledger Excel", severity: "error" });
        } finally {
            setLedgerExcelLoading(false);
        }
    };

    const fetchData = async (fd, td, rt, groupIds) => {
        const usedFromDate    = fd || fromDate;
        const usedToDate      = td || toDate;
        const usedReportType  = rt || reportType;
        if (!usedFromDate || !usedToDate) { setSnackbar({ open: true, message: "Select a date range first", severity: "warning" }); return; }
        if (usedReportType === "Groupwise Item") {
            const usedGroupIds = groupIds || selectedGroupIds;
            if (!usedGroupIds || usedGroupIds.length === 0) { setSnackbar({ open: true, message: "Please select at least one group", severity: "warning" }); return; }
        }
        try {
            setLoading(true);
            const params = { compId: companyId, fromDate: usedFromDate, toDate: usedToDate, reportType: usedReportType };
            if (usedReportType === "Groupwise Item") params.groupIds = (groupIds || selectedGroupIds).join(",");
            const res = await axios.get(`${connectionString}/api/getStockReport`, { params });
            const data = (res.data.details || []).map((row, idx) => {
                const closing  = Number(row.Closing || 0);
                const minLevel = Number(row.MinLevel || 0);
                return {
                    id: idx + 1, srNo: idx + 1,
                    itemId: row.Id, itemCode: row.ItemCode, description: row.Description, unit: row.Unit,
                    OpStock: row.OpStock || 0, inward: row.Inward || 0, outward: row.Outward || 0, closing,
                    avgRate: row.AvgPurcRate || 0, purcRate: row.PurchaseRate || row.PurcRate || 0,
                    lastPurcRate: row.LastPurcRate || 0, stockValuation: row.StockValuation || row.AmountInRs || 0,
                    minLevel, shortageQty: minLevel > closing ? closing - minLevel : 0,
                    maxLevel: row.MaxLevel || 0, excessQty: row.ExcessQty || 0, groupName: row.GroupName || "",
                };
            });
            setRows(data);
        } catch {
            setSnackbar({ open: true, message: "Failed to fetch stock data", severity: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleGetData = async () => {
        if (!tempFromDate || !tempToDate) { setSnackbar({ open: true, message: "Select a date range first", severity: "warning" }); return; }
        if (tempReportType === "Groupwise Item" && tempSelectedGroupIds.length === 0) { setSnackbar({ open: true, message: "Please select at least one group", severity: "warning" }); return; }
        setFromDate(tempFromDate); setToDate(tempToDate); setReportType(tempReportType);
        setShowZeroRecords(tempShowZeroRecords); setSelectedGroupIds(tempSelectedGroupIds);
        setAppliedFilters({ fromDate: tempFromDate, toDate: tempToDate, reportType: tempReportType, showZeroRecords: tempShowZeroRecords, selectedGroupIds: tempSelectedGroupIds });
        setFilterOpen(false);
        await fetchData(tempFromDate, tempToDate, tempReportType, tempSelectedGroupIds);
    };

    const handleRefresh = () => fetchData(fromDate, toDate, reportType, selectedGroupIds);

    const buildExcelData = () => filteredRows.map((row) => {
        const base = {
            "Sr No": row.srNo,
            ...(reportType === "Groupwise Item" ? { "Group": row.groupName || "" } : {}),
            "Item Code": row.itemCode, "Description": row.description, "Unit": row.unit,
            "Opening Stock": Number(row.OpStock || 0), "Inward": Number(row.inward || 0),
            "Outward": Number(row.outward || 0), "Closing": Number(row.closing || 0),
        };
        switch (reportType) {
            case "Average Rate":       return { ...base, "Avg. Rate": Number(row.avgRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
            case "Purchase Rate":      return { ...base, "Purc. Rate": Number(row.purcRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
            case "Last Purchase Rate": return { ...base, "Last Purc. Rate": Number(row.lastPurcRate || 0), "Amount (Rs.)": Number(row.stockValuation || 0) };
            case "Min Level":          return { ...base, "Min Level": Number(row.minLevel || 0), "Shortage Qty": Number(row.shortageQty || 0) };
            case "Max Level":          return { ...base, "Max Level": Number(row.maxLevel || 0), "Excess Qty": Number(row.excessQty || 0) };
            default:                   return base;
        }
    });

    const handleExport = () => {
        if (!filteredRows.length) return;
        try {
            setExcelLoading(true);
            const ws = XLSX.utils.json_to_sheet(buildExcelData());
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Stock Report");
            const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([buf], { type: "application/octet-stream" }), `Stock_Report_${reportType.replace(/\s+/g, "_")}_${fromDate}_to_${toDate}.xlsx`);
            setSnackbar({ open: true, message: "Excel downloaded!", severity: "success" });
        } catch {
            setSnackbar({ open: true, message: "Failed to generate Excel", severity: "error" });
        } finally {
            setExcelLoading(false);
        }
    };

    const handleClear = () => {
        setFromDate(getTodayDate()); setToDate(getTodayDate()); setRows([]);
        setReportType("General Stock Report"); setAppliedFilters(null);
        setShowZeroRecords(false); setTempShowZeroRecords(false);
        setSelectedGroupIds([]); setTempSelectedGroupIds([]);
    };

    // ─── DATAGRID COLUMNS ─────────────────────────────────────────────
    const baseColumns = [
        { field: "srNo", headerName: "#", width: 50, align: "center", headerAlign: "center" },
        ...(reportType === "Groupwise Item" ? [{
            field: "groupName", headerName: "Group", flex: 1, minWidth: 120,
            renderCell: ({ value }) => (
                <Box sx={{ display: "inline-flex", alignItems: "center", px: "7px", height: "22px", background: FB_LIGHT, borderRadius: "6px" }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB, lineHeight: 1 }}>{value || "—"}</Typography>
                </Box>
            ),
        }] : []),
        {
            field: "itemCode", headerName: "Item Code", flex: 1, minWidth: 110,
            renderCell: ({ value, row }) => (
                <Typography onClick={() => fetchStockLedger(row.itemId, row.itemCode, row.description)}
                    sx={{ fontSize: 13, fontWeight: 600, color: FB, cursor: "pointer", textDecoration: "underline", "&:hover": { color: FB_DARK } }}>
                    {value}
                </Typography>
            ),
        },
        {
            field: "description", headerName: "Description", flex: 2, minWidth: 160,
            renderCell: ({ value }) => (
                <Typography sx={{ fontSize: 13, color: G900, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>{value}</Typography>
            ),
        },
        {
            field: "unit", headerName: "Unit", width: 80,
            renderCell: ({ value }) => value ? (
                <Box sx={{ display: "inline-flex", alignItems: "center", px: "7px", height: "22px", background: FB_LIGHT, borderRadius: "6px" }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB, lineHeight: 1 }}>{value}</Typography>
                </Box>
            ) : <Typography sx={{ fontSize: 13, color: G500 }}>—</Typography>,
        },
        {
            field: "OpStock", headerName: "Op. Stock", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
            renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography>,
        },
        {
            field: "inward", headerName: "Inward", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
            renderCell: ({ value }) => (
                <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? FB : G500 }}>{fmt(value)}</Typography>
            ),
        },
        {
            field: "outward", headerName: "Outward", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
            renderCell: ({ value }) => (
                <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? G700 : G500 }}>{fmt(value)}</Typography>
            ),
        },
        {
            field: "closing", headerName: "Closing", flex: 1, minWidth: 90, align: "right", headerAlign: "right",
            renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(value)}</Typography>,
        },
    ];

    const getExtraColumns = () => {
        const extraColor = G900;
        switch (reportType) {
            case "Average Rate":
                return [
                    { field: "avgRate",        headerName: "Avg. Rate",     flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                    { field: "stockValuation", headerName: "Amount (Rs.)",  flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                ];
            case "Purchase Rate":
                return [
                    { field: "purcRate",       headerName: "Purc. Rate",    flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                    { field: "stockValuation", headerName: "Amount (Rs.)",  flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                ];
            case "Last Purchase Rate":
                return [
                    { field: "lastPurcRate",   headerName: "Last Purc. Rate", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                    { field: "stockValuation", headerName: "Amount (Rs.)",    flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                ];
            case "Min Level":
                return [
                    { field: "minLevel",    headerName: "Min Level",    flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                    { field: "shortageQty", headerName: "Shortage Qty", flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                ];
            case "Max Level":
                return [
                    { field: "maxLevel",  headerName: "Max Level",  flex: 1, minWidth: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                    { field: "excessQty", headerName: "Excess Qty", flex: 1, minWidth: 110, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: extraColor }}>{fmt(value)}</Typography> },
                ];
            default: return [];
        }
    };

    const columns = (reportType === "General Stock Report" || reportType === "Groupwise Item") ? baseColumns : [...baseColumns, ...getExtraColumns()];

    // ─── LEDGER COLUMNS ───────────────────────────────────────────────
    const ledgerColumns = [
        { field: "srNo", headerName: "#", width: 50, align: "center", headerAlign: "center" },
        { field: "stockDate", headerName: "Date",      width: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{value || "—"}</Typography> },
        {
            field: "bookName", headerName: "Book Name", width: 100,
            renderCell: ({ value }) => (
                <Box sx={{ px: "7px", py: "2px", background: FB_LIGHT, borderRadius: "6px" }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{value}</Typography>
                </Box>
            ),
        },
        { field: "docNo",    headerName: "Doc No",     width: 150, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{value || "—"}</Typography> },
        { field: "firmName", headerName: "Party Name", flex: 1, minWidth: 110, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>{value || "—"}</Typography> },
        { field: "opStock",     headerName: "Op. Stock", width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography> },
        { field: "stockInQty",  headerName: "Inward",    width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? FB : G500 }}>{fmt(value)}</Typography> },
        { field: "stockOutQty", headerName: "Outward",   width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: Number(value) ? 600 : 400, color: Number(value) ? G700 : G500 }}>{fmt(value)}</Typography> },
        { field: "rate",   headerName: "Rate",    width: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900 }}>{fmt(value)}</Typography> },
        { field: "disc",   headerName: "Disc",    width: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: Number(value) ? G700 : G500, fontWeight: Number(value) ? 600 : 400 }}>{fmt(value)}</Typography> },
        { field: "balance", headerName: "Closing", width: 100, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(value)}</Typography> },
    ];

    // ─── TOTALS BAR DATA ──────────────────────────────────────────────
    const getTotalsItems = () => {
        const base = [
            { label: "Op. Bal", value: fmt(totOp),  color: G900 },
            { label: "Inward",  value: fmt(totIn),  color: FB   },
            { label: "Outward", value: fmt(totOut), color: G700 },
            { label: "Closing", value: fmt(totCl),  color: FB   },
        ];
        if (reportType === "Average Rate")
            return [...base, { label: "Avg. Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.avgRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
        if (reportType === "Purchase Rate")
            return [...base, { label: "Purc. Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.purcRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
        if (reportType === "Last Purchase Rate")
            return [...base, { label: "Last Rate", value: fmt(filteredRows.reduce((s, r) => s + Number(r.lastPurcRate || 0), 0)), color: G900 }, { label: "Amount", value: fmt(totStockVal), color: G900 }];
        if (reportType === "Min Level")
            return [...base, { label: "Min Level", value: fmt(filteredRows.reduce((s, r) => s + Number(r.minLevel || 0), 0)), color: G900 }, { label: "Shortage", value: fmt(filteredRows.reduce((s, r) => s + Number(r.shortageQty || 0), 0)), color: G700 }];
        if (reportType === "Max Level")
            return [...base, { label: "Max Level", value: fmt(filteredRows.reduce((s, r) => s + Number(r.maxLevel || 0), 0)), color: G900 }, { label: "Excess", value: fmt(filteredRows.reduce((s, r) => s + Number(r.excessQty || 0), 0)), color: G900 }];
        return base;
    };

    // ─── ENTERPRISE PAGE HEADER ───────────────────────────────────────
    const pageHeader = (title, subtitle, actions) => (
        <Box sx={{ background: NAVY, display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, minHeight: 56, flexShrink: 0, gap: 2 }}>
            <Box sx={{ width: 30, height: 30, borderRadius: "4px", background: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <BarChartIcon sx={{ fontSize: 17, color: WHITE }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1.2 }}>{title}</Typography>
                {subtitle && <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "2px" }}>{subtitle}</Typography>}
            </Box>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexShrink: 0 }}>{actions}</Box>
        </Box>
    );

    // ─── RENDER ───────────────────────────────────────────────────────
    return (
        <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>

            {currentView === "report" ? (
                <>
                    {/* ── HEADER ── */}
                    {pageHeader(
                        "Stock Report",
                        appliedFilters ? `${filteredRows.length} items · ${appliedFilters.fromDate} – ${appliedFilters.toDate}` : "Inventory movement & valuation",
                        <>
                            {appliedFilters && (
                                <Button onClick={handleRefresh} disabled={loading}
                                    startIcon={loading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <RefreshIcon sx={{ fontSize: 14 }} />}
                                    sx={btnHeaderGhost}>
                                    {isMobile ? "" : "Refresh"}
                                </Button>
                            )}
                            {filteredRows.length > 0 && (
                                <>
                                    <Button onClick={handleExport} disabled={excelLoading}
                                        startIcon={excelLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                                        sx={btnHeaderGhost}>
                                        {isMobile ? "Excel" : "Export Excel"}
                                    </Button>
                                    <Button onClick={handleStockPdf} disabled={pdfLoading}
                                        startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                                        sx={btnHeaderGhost}>
                                        {isMobile ? "PDF" : "Generate PDF"}
                                    </Button>
                                </>
                            )}
                            <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
                                {isMobile ? "Filter" : "Configure Report"}
                            </Button>
                        </>
                    )}

                    {/* ── KPI SUMMARY CARDS ── */}
                    {filteredRows.length > 0 && (
                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: `repeat(${Math.min(getTotalsItems().length, 5)}, 1fr)` }, gap: { xs: 1, sm: 1.5 }, px: { xs: 1.5, sm: 2 }, pt: { xs: 1.5, sm: 2 }, pb: 0 }}>
                            {getTotalsItems().map(({ label, value, color }) => (
                                <Box key={label} sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", p: "12px 14px", borderLeft: `3px solid ${color === POS || color === FB ? STEEL : NAVY}` }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".7px", mb: "8px" }}>{label}</Typography>
                                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>{value}</Typography>
                                </Box>
                            ))}
                        </Box>
                    )}

                    {/* ── CONTENT CARD ── */}
                    <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
                        <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>
                            {/* Active filter status bar */}
                            {appliedFilters && (
                                <Box sx={{ px: { xs: 1.5, sm: 2 }, py: "9px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: TH_BG, borderBottom: `1px solid ${BORDER}` }}>
                                    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
                                        <Typography sx={{ fontSize: 10, color: T3, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", mr: 0.5 }}>Active Filters:</Typography>
                                        {[
                                            appliedFilters.reportType,
                                            `${appliedFilters.fromDate} – ${appliedFilters.toDate}`,
                                            ...(appliedFilters.reportType === "Groupwise Item" && appliedFilters.selectedGroupIds?.length > 0 ? [`${appliedFilters.selectedGroupIds.length} group${appliedFilters.selectedGroupIds.length > 1 ? "s" : ""}`] : []),
                                            ...(appliedFilters.showZeroRecords ? ["Zero items shown"] : []),
                                        ].map(tag => (
                                            <Box key={tag} sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
                                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{tag}</Typography>
                                            </Box>
                                        ))}
                                        <Box sx={{ px: 1, py: "2px", background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "3px", display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Inventory2OutlinedIcon sx={{ fontSize: 12, color: T3 }} />
                                            <Typography sx={{ fontSize: 11, fontWeight: 600, color: T1 }}>{filteredRows.length} items</Typography>
                                        </Box>
                                    </Box>
                                    <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 11 }} />} sx={btnGhost}>
                                        Clear
                                    </Button>
                                </Box>
                            )}

                            {loading ? (
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: "3rem" }}>
                                    <CircularProgress size={22} sx={{ color: STEEL }} />
                                    <Typography sx={{ fontSize: 13, color: T3 }}>Loading stock data…</Typography>
                                </Box>

                            ) : !appliedFilters ? (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "4rem", gap: 2 }}>
                                    <BarChartIcon sx={{ fontSize: 36, color: T3 }} />
                                    <Box sx={{ textAlign: "center" }}>
                                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: T1, mb: "4px" }}>No Report Selected</Typography>
                                        <Typography sx={{ fontSize: 12, color: T3 }}>Configure report type &amp; date range to get started</Typography>
                                    </Box>
                                    <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnPrimary}>Configure & Run Report</Button>
                                </Box>

                            ) : filteredRows.length === 0 ? (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 1 }}>
                                    <BarChartIcon sx={{ fontSize: 30, color: BORDER }} />
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: T1 }}>No data found</Typography>
                                    <Typography sx={{ fontSize: 12, color: T3 }}>Try changing the date range or report type</Typography>
                                </Box>

                            ) : isMobile ? (
                                <Box sx={{ p: 1.25 }}>
                                    {filteredRows.map((row) => <MobileCard key={row.id} row={row} fmt={fmt} reportType={reportType} />)}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", pt: 1, px: 0.5 }}>
                                        <Typography sx={{ fontSize: 12, color: G500 }}>{filteredRows.length} items</Typography>
                                        <Typography sx={{ fontSize: 12, color: G500 }}>{fromDate} → {toDate}</Typography>
                                    </Box>
                                </Box>

                            ) : (
                                <>
                                    <DataGrid
                                        rows={filteredRows} columns={columns}
                                        autoHeight rowHeight={40}
                                        disableRowSelectionOnClick hideFooterSelectedRowCount
                                        pageSizeOptions={[25, 50, 100]}
                                        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                                        sx={dgSx}
                                    />
                                    {/* Totals footer */}
                                    <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
                                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
                                            {filteredRows.length} items
                                        </Typography>
                                        <Box sx={{ display: "flex", gap: { xs: 2, sm: 4 }, ml: "auto", flexWrap: "wrap" }}>
                                            {getTotalsItems().map(({ label, value }) => (
                                                <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                                    <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
                                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums" }}>{value}</Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Box>
                </>

            ) : (
                <>
                    {/* ── LEDGER HEADER ── */}
                    {pageHeader(
                        "Stock Ledger",
                        selectedItem ? `Stock Report › ${selectedItem.itemCode} · ${selectedItem.description}` : "",
                        <>
                            <Button onClick={handleBackToReport} startIcon={<ArrowBackIcon sx={{ fontSize: 14 }} />} sx={btnHeaderGhost}>
                                Back to Report
                            </Button>
                            {ledgerRows.length > 0 && (
                                <>
                                    <Button onClick={handleLedgerExport} disabled={ledgerExcelLoading}
                                        startIcon={ledgerExcelLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                                        sx={btnHeaderGhost}>
                                        {isMobile ? "Excel" : "Export Excel"}
                                    </Button>
                                    <Button
                                        onClick={async () => {
                                            setPdfLoading(true);
                                            try {
                                                let imageBase64 = null;
                                                try {
                                                    const iconRes = await axios.get(`${connectionString}/company/GetIcon/${encodeURIComponent(companyId)}`);
                                                    if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                                                        const raw = iconRes.data.imageBase64;
                                                        imageBase64 = typeof raw === "string" ? raw.split("base64,").pop()?.replace(/\s/g, "") || null : null;
                                                    }
                                                } catch {}
                                                const pdfData = {
                                                    fromDate, toDate, imageBase64: imageBase64 || null,
                                                    entries: ledgerRows.map((row) => ({
                                                        stockDate: row.stockDate || "", bookName: row.bookName || "", docNo: row.docNo || "",
                                                        firmName: row.firmName || "", opStock: Number(row.opStock || 0),
                                                        stockInQty: Number(row.stockInQty || 0), stockOutQty: Number(row.stockOutQty || 0),
                                                        rate: Number(row.rate || 0), disc: Number(row.disc || 0), balance: Number(row.balance || 0),
                                                        itemCode: selectedItem?.itemCode || "", description: selectedItem?.description || "", unit: row.unit || "",
                                                    })),
                                                };
                                                const companyHeader = selectedCompany ? {
                                                    CompId: companyId,
                                                    CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
                                                    Address: selectedCompany.Address || selectedCompany.address || "",
                                                    MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
                                                    GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
                                                    EmailId: selectedCompany.EmailId || "",
                                                    Website: selectedCompany.Website || "",
                                                    imageBase64: imageBase64 || null,
                                                } : null;
                                                const pdfResp = await axios.post(
                                                    `${pdfString}/api/stock-pdf/format_8`,
                                                    { docId: `stock-format_8-${fromDate}-${toDate}`, data: pdfData, company: companyHeader, companyIconFormat: "jpg" },
                                                    { responseType: "blob" }
                                                );
                                                const blob = pdfResp.data;
                                                if (!blob || blob.size === 0) throw new Error("Empty PDF");
                                                const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                                                if (window.ReactNativeWebView) {
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => window.ReactNativeWebView.postMessage(JSON.stringify({ type: "OPEN_PDF", base64: reader.result }));
                                                    reader.readAsDataURL(blob);
                                                } else {
                                                    const newWin = window.open(blobUrl, "_blank");
                                                    if (newWin) {
                                                        newWin.focus();
                                                        const timer = setInterval(() => { if (newWin.closed) { URL.revokeObjectURL(blobUrl); clearInterval(timer); } }, 1000);
                                                    } else {
                                                        setSnackbar({ open: true, message: "Popup blocked – allow popups", severity: "warning" });
                                                    }
                                                }
                                                setSnackbar({ open: true, message: "PDF generated!", severity: "success" });
                                            } catch (err) {
                                                setSnackbar({ open: true, message: `PDF failed: ${err.message || "Unknown error"}`, severity: "error" });
                                            } finally {
                                                setPdfLoading(false);
                                            }
                                        }}
                                        disabled={pdfLoading}
                                        startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                                        sx={btnHeaderGhost}>
                                        {isMobile ? "PDF" : "Generate PDF"}
                                    </Button>
                                </>
                            )}
                        </>
                    )}

                    {/* Ledger context bar */}
                    <Box sx={{ background: TH_BG, borderBottom: `1px solid ${BORDER}`, px: { xs: 2, sm: 3 }, py: "8px", display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0, flexWrap: "wrap" }}>
                        <Box sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{fromDate} – {toDate}</Typography>
                        </Box>
                        {ledgerRows.length > 0 && (
                            <Box sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{ledgerRows.length} entries</Typography>
                            </Box>
                        )}
                    </Box>

                    {/* ── LEDGER CONTENT ── */}
                    <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
                        <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>
                            {ledgerLoading ? (
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, py: "3rem" }}>
                                    <CircularProgress size={22} sx={{ color: STEEL }} />
                                    <Typography sx={{ fontSize: 13, color: T3 }}>Loading ledger…</Typography>
                                </Box>
                            ) : ledgerRows.length === 0 ? (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 1 }}>
                                    <BarChartIcon sx={{ fontSize: 30, color: BORDER }} />
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: T1 }}>No ledger entries found</Typography>
                                    <Typography sx={{ fontSize: 12, color: T3 }}>No stock movements for this item in the selected period</Typography>
                                </Box>
                            ) : isMobile ? (
                                <Box sx={{ p: 1.25 }}>
                                    {ledgerRows.map((row) => <MobileLedgerCard key={row.id} row={row} fmt={fmt} />)}
                                </Box>
                            ) : (
                                <>
                                    <DataGrid
                                        rows={ledgerRows} columns={ledgerColumns}
                                        autoHeight rowHeight={40}
                                        disableRowSelectionOnClick hideFooterSelectedRowCount
                                        pageSizeOptions={[25, 50, 100]}
                                        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                                        sx={dgSx}
                                    />
                                    {/* Ledger totals footer */}
                                    <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
                                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
                                            {ledgerRows.length} entries
                                        </Typography>
                                        <Box sx={{ display: "flex", gap: { xs: 2, sm: 4 }, ml: "auto", flexWrap: "wrap" }}>
                                            {[
                                                { label: "Inward",  value: fmt(ledgerRows.reduce((s, r) => s + Number(r.stockInQty  || 0), 0)) },
                                                { label: "Outward", value: fmt(ledgerRows.reduce((s, r) => s + Number(r.stockOutQty || 0), 0)) },
                                                { label: "Closing", value: fmt(ledgerRows.length ? Number(ledgerRows[ledgerRows.length - 1].balance || 0) : 0) },
                                            ].map(({ label, value }) => (
                                                <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                                    <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
                                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums" }}>{value}</Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Box>
                </>
            )}

            {/* ── REPORT CONFIGURATION DIALOG ── */}
            <StockReportFilterDialog
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                loading={loading}
                tempReportType={tempReportType}
                handleTempReportTypeChange={handleTempReportTypeChange}
                reportOptions={reportOptions}
                tempSelectedGroupIds={tempSelectedGroupIds}
                itemGroups={itemGroups}
                itemGroupsLoading={itemGroupsLoading}
                handleSelectAllGroups={handleSelectAllGroups}
                handleGroupToggle={handleGroupToggle}
                tempFromDate={tempFromDate}
                setTempFromDate={setTempFromDate}
                tempToDate={tempToDate}
                setTempToDate={setTempToDate}
                tempShowZeroRecords={tempShowZeroRecords}
                setTempShowZeroRecords={setTempShowZeroRecords}
                onGetData={handleGetData}
            />

            {/* ── SNACKBAR ── */}
            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                <Alert severity={snackbar.severity} variant="filled" onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
